import { styled } from '@mui/material/styles'

export const WizardContent = styled('div', {
  name: 'WizardContent',
  slot: 'Root',
  skipSx: true,
  skipVariantsResolver: true,
})`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
`
